<template>
  <div
    class="p-4 pt-0 gap-4 flex flex-1 flex-col items-center justify-between font-normal overflow-auto"
  >
    <div v-if="!explanation.content"></div>

    <!-- <div
      v-if="!isTutorial"
      class="gap-4 p-4 flex flex-col flex-initial justify-center leading-normal"
    >
      <div class="gap-4 flex items-center text-left text-error">
        <BaseIcon class="text-sm" icon="cross" />
        <span v-html="formattedIncorrectAnswer" />
      </div>

      <div class="gap-4 flex items-center text-left text-success">
        <BaseIcon class="text-sm" icon="check" />
        <span v-html="formattedCorrectAnswer" />
      </div>
    </div> -->

    <div class="mb-8 flex flex-1 items-start w-full">
      <div
        id="explanation-wrapper"
        class="w-full flex flex-col rounded-2xl"
        :class="{ 'my-auto': isTutorial }"
      >
        <div
          class="mb-8 flex flex-col flex-initial justify-center leading-normal"
        >
          <div
            v-if="isIncorrect"
            class="gap-2 flex items-start text-left text-error"
          >
            <BaseIcon class="mt-1 text-sm" icon="cross" />
            <span v-html="formattedIncorrectAnswer" />
          </div>

          <div class="gap-2 flex items-start text-left text-success">
            <BaseIcon class="mt-1 text-sm" icon="check" />
            <span v-html="formattedCorrectAnswer" />
          </div>
        </div>

        <div v-if="explanation.isLoading" class="w-full">
          <span class="text-sm text-[#7C7C7C] flex items-center gap-2">
            <BaseLoader color="dark" class="scale-[0.25]" />
            <span class="heartbeat" style="animation-delay: 3s">
              {{ $t('hub.exercises.wrongAnswer.generatingExplanation') }}
            </span>
          </span>
        </div>

        <template v-if="explanation.content && !explanation.isLoading">
          <div class="prose">
            <span class="font-semibold">Explanation: </span>

            <span class="prose whitespace-pre-line">
              {{ explanation.content }}
            </span>

            <br />

            <div v-if="rule && !isShowRule" class="mt-4">
              <button
                class="px-2 py-1 rounded-md border border-success bg-success/10 text-sm text-success flex items-center gap-1 cursor-pointer hover:text-[#5a5a5a]"
                @click="isShowRule = true"
              >
                <span>Show full explanation</span>

                <BaseIcon class="text-sm" icon="angle-small-down" />
              </button>
            </div>

            <br />

            <span
              class="text-sm text-[#7C7C7C] flex items-center gap-2 underline cursor-pointer"
              @click="() => $emit('open-settings')"
            >
              Explanation in {{ activeExplanationLanguageObject.flag }}
              {{ activeExplanationLanguageObject.name }} (click here to change)
            </span>
          </div>
        </template>

        <GrammarRule v-if="rule && isShowRule" class="mb-2" :rule="rule" />

        <div
          v-if="
            !isDemo &&
            !isTutorial &&
            isCorrect &&
            (settings.isCorrectAnswerExplanations ||
              isJustSkippedCorrectAnswerExplanation)
          "
        >
          <br />
          <br />

          <span
            v-if="isJustSkippedCorrectAnswerExplanation"
            class="text-sm text-[#7C7C7C] inline-flex items-center gap-1 flex-wrap"
          >
            <span class="inline-flex items-center whitespace-nowrap">
              {{ $t('hub.exercises.correctAnswer.settingsHint.before') }}
              <BaseIcon class="inline mx-1" icon="user-gear" />
              {{ $t('hub.exercises.correctAnswer.settingsHint.after') }}
            </span>
          </span>

          <span
            v-else
            class="text-sm text-[#7C7C7C] flex items-center gap-2 underline cursor-pointer"
            @click="handleSkipCorrectAnswerExplanation"
          >
            {{ $t('hub.exercises.correctAnswer.skipExplanation') }}
          </span>
        </div>
      </div>
    </div>

    <div
      class="sticky bottom-0 w-full mx-auto gap-4 px-4 flex flex-col items-center"
    >
      <!-- <BaseButton
        v-if="!explanation.content"
        color="dark"
        class="heartbeat"
        style="animation-delay: 10s"
        :is-loading="explanation.isLoading"
        @click="handleShowExplanation"
      >
        <span class="text-lg">✨ Переглянути пояснення</span>
      </BaseButton> -->

      <!-- Settings moved to modal -->

      <BaseButton id="continue-button" class="w-full" @click="$emit('close')">
        {{ $t('hub.exercises.wrongAnswer.continue') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import BaseButton from '@/components/Base/BaseButton.vue'
import BaseLoader from '@/components/Base/BaseLoader.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'

import GrammarRule from '@/components/Grammar/GrammarRule.vue'

import sectionsTopicsRules from '@/data/sections-topics-rules'

export default {
  name: 'HubExercisesPostAnswer',

  components: { BaseButton, BaseIcon, BaseLoader, GrammarRule },

  props: {
    sectionSlug: { type: String, required: true },
    topicSlug: { type: String, required: true },

    isTutorial: {
      type: Boolean,
      default: false
    },

    isDemo: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    explanation: {
      isLoading: false,
      content: ''
    },

    isJustSkippedCorrectAnswerExplanation: false,
    isShowRule: false
  }),

  computed: {
    ...mapGetters('locale', ['currentLocale']),
    ...mapGetters('exercises', ['activeExplanationLanguageObject']),
    ...mapState('exercises', ['exercises', 'settings']),

    isCorrect() {
      return this.historyItem.isCorrect
    },

    isIncorrect() {
      return !this.isCorrect
    },

    historyItem() {
      return this.exercises.history.at(-1)
    },

    correctAnswer() {
      return this.historyItem.exercise.answers[0]
    },

    incorrectAnswer() {
      return this.historyItem.answer
    },

    rule() {
      const section = sectionsTopicsRules.sections.find(
        s => s.slug === this.sectionSlug
      )

      const topic = section?.topics.find(t => t.slug === this.topicSlug)

      const rule = topic?.rule || null

      return rule
    },

    formattedCorrectAnswer() {
      return this.historyItem.exercise.text.replace(
        '___',
        `<strong>${this.correctAnswer}</strong>`
      )
    },

    formattedIncorrectAnswer() {
      return this.historyItem.exercise.text.replace(
        '___',
        `<strong class="line-through">${this.incorrectAnswer}</strong>`
      )
    }
  },

  created() {
    if (this.isTutorial) {
      this.explanation.content = this.isCorrect
        ? this.$t('tutorial.correctAnswerExplanation')
        : this.$t('tutorial.wrongAnswerExplanation')

      return
    }

    this.handleShowExplanation()
  },

  methods: {
    ...mapActions('exercises', {
      generateExplanation: 'GENERATE_EXPLANATION'
    }),
    ...mapMutations('exercises', {
      setIsCorrectAnswerExplanations: 'SET_IS_CORRECT_ANSWER_EXPLANATIONS'
    }),

    async handleShowExplanation() {
      this.$gtag.event('exercise_explanation_submitted')

      this.explanation.isLoading = true

      const { content } = await this.generateExplanation({
        historyItem: this.historyItem
      })

      this.explanation.isLoading = false
      this.explanation.content = content?.choices?.[0]?.message?.content || ''

      if (this.explanation.content) {
        this.$gtag.event('exercise_explanation_success')
      }
    },

    handleSkipCorrectAnswerExplanation() {
      this.isJustSkippedCorrectAnswerExplanation = true
      this.setIsCorrectAnswerExplanations(false)
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes heartbeat {
  0%,
  10% {
    transform: scale(1);
  }
  15% {
    transform: scale(0.95);
  }
  20% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.95);
  }
  30% {
    transform: scale(1);
  }
  100% {
    transform: scale(1); /* Pause for the remaining time */
  }
}

.heartbeat {
  animation: heartbeat 10s ease-in-out infinite; /* 10s total duration */
}
</style>
